export const isIOSDevice = (): boolean =>
  typeof navigator !== 'undefined' &&
  /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
